//MODEL: nothing

define('app/nav/ResetPassword',['require','glu/itemView','config','glu/dialog','glu/http','hbs!./ResetPassword.hbs'],function(require) {
	'use strict';


	var ItemView = require('glu/itemView'),
		config = require('config'),
		dialog = require('glu/dialog'),
		http = require('glu/http');

	var view = ItemView.extend({

		template: require('hbs!./ResetPassword.hbs'),

		modalClass: 'passwd-dialog-no-x-button',

		ui: {
			$username: '#reset-username',
			$passwordNew1: '#reset-password1',
			$passwordNew2: '#reset-password2'
		},

		events: {
			'click .btn-submit-reset-password': 'doSubmit'
		},

		onRender: function() {},

		getuiNewPassword1: function() {
			return this.ui.$passwordNew1.val().trim();
		},

		getuiNewPassword2: function() {
			return this.ui.$passwordNew2.val().trim();
		},

		setToken: function(token) {
			this.token = token;
		},

		doSubmit: function(evt) {
			var pNew1 = this.getuiNewPassword1();
			var pNew2 = this.getuiNewPassword2();

			//clear border colors (old errors)
			this.ui.$passwordNew1.parent().removeClass('has-error');
			this.ui.$passwordNew2.parent().removeClass('has-error');

			//verify none of the fields is blank and new password strings match
			var err = false;
			if (pNew1.length === 0) {
				this.ui.$passwordNew1.parent().addClass('has-error');
				err = true;
			}
			if (pNew2.length === 0) {
				this.ui.$passwordNew2.parent().addClass('has-error');
				err = true;
			}
			if (pNew1 !== pNew2) { //verify pNew1 == pNew2
				this.ui.$passwordNew1.parent().addClass('has-error');
				this.ui.$passwordNew2.parent().addClass('has-error');
				err = true;
			}
			if (!this.validatePassword(pNew1)) {
				this.ui.$passwordNew1.parent().addClass('has-error');
				this.ui.$passwordNew2.parent().addClass('has-error');
				err = true;
			}

			if (err) {
				evt.preventDefault();
				return false;
			}

			var self = this;
			http.post(config.apiRoot + 'auth/resetpasswd/' + this.token, {
				username: self.getUsername(),
				password: self.getuiNewPassword1()
			}).then(function() {
				dialog.alert('Your password has been changed, please go to Login page to sign into your account.', 'Password Reset');
				self.ui.$username.val('');
				self.ui.$passwordNew1.val('');
				self.ui.$passwordNew2.val('');
			}, function(xhr) {
				dialog.alert('There was an error resetting your password: ' + xhr.responseJSON.errorMessage, 'Password Reset');
			});
			return false;

		},

		serializeData: function() {
			return this;
		},

		validatePassword: function(password) {
			var errors = [];

			if (password.length < 8) {
				errors.push('Your password must be at least 8 characters');
			}
			if (password.length > 160) {
				errors.push('Your password must be at most 160 characters');
			}
			if (password.search(/[a-z]/) < 0) {
				errors.push('Your password must contain at least one letter.');
			}
			if (password.search(/[0-9]/) < 0) {
				errors.push('Your password must contain at least one digit.');
			}
			if (password.search(/[A-Z]/) < 0) {
				errors.push('Your password must contain at least one upper case letter.');
			}
			if (password.search(/[!@#$%^&*?]/) < 0) {
				errors.push('Your password must contain at least one special character from [!@#$%^&*?].');
			}
			if (errors.length > 0) {
				return false;
			}
			return true;
		},

		getUsername: function() {
			return this.$el.find(this.ui.$username).val().toString().toLocaleLowerCase();
		}
	});

	return view;
});

